import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { EditRivenditoreModalComponent } from './edit-rivenditore-modal';

export const EditRivenditoreModalModule: string = ng
    .module('archiSmall.components.editRivenditoreModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('editRivenditoreModalComponent', EditRivenditoreModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/edit-rivenditore-modal/edit-rivenditore-modal.module.ts